var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var ChevronLeftIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { strokeWidth: "0" },
        React.createElement("polygon", { id: "path-1", points: "15.41 7.41 14 6 8 12 14 18 15.41 16.59 10.83 12" })))); };
export default ChevronLeftIcon;
//# sourceMappingURL=ChevronLeftIcon.js.map